import React, { Component } from 'react'
import { Modal, Button } from 'react-bootstrap'

import { connect } from 'react-redux'

import { selectImage, clearImageSelection } from '../actions/galleryActions'

import img2 from '../img/gallery/img_2.jpg'
import img3 from '../img/gallery/img_3.jpg'
import img4 from '../img/gallery/img_4.jpg'
import img5 from '../img/gallery/img_5.jpg'
import img6 from '../img/gallery/img_6.jpg'
import img7 from '../img/gallery/img_7.jpg'
import img8 from '../img/gallery/img_8.jpg'
import img9 from '../img/gallery/img_9.jpg'
import img10 from '../img/gallery/img_10.jpg'
import img11 from '../img/gallery/img_11.jpg'
import img12 from '../img/gallery/img_12.jpg'
import img13 from '../img/gallery/img_13.jpg'
import img14 from '../img/gallery/img_14.jpg'
import img15 from '../img/gallery/img_15.jpg'
import img16 from '../img/gallery/img_16.jpg'
import img17 from '../img/gallery/img_17.jpg'
import img18 from '../img/gallery/img_18.jpg'
import img19 from '../img/gallery/img_19.jpg'
import img20 from '../img/gallery/img_20.jpg'
import img21 from '../img/gallery/img_21.jpg'
import img22 from '../img/gallery/img_22.jpg'
import img23 from '../img/gallery/img_23.jpg'


class Gallery extends Component {

    constructor(props) {
        super(props);
        this.close = this.close.bind(this);
        this.open = this.open.bind(this);
        this.state = { showModal: false };
    }

    close() {
        this.setState({ showModal: false });
    }

    open(event) {
        this.setState({ 
            showModal: true , 
            selectedImage: event.target.src
        });
    }

    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="box">
                        <div className="col-lg-3 col-sm-4 col-xs-6"><a onClick={this.open}><img className="thumbnail img-responsive" src={img2} /></a></div>
                        <div className="col-lg-3 col-sm-4 col-xs-6"><a onClick={this.open}><img className="thumbnail img-responsive" src={img3} /></a></div>
                        <div className="col-lg-3 col-sm-4 col-xs-6"><a onClick={this.open}><img className="thumbnail img-responsive" src={img4} /></a></div>
                        <div className="col-lg-3 col-sm-4 col-xs-6"><a onClick={this.open}><img className="thumbnail img-responsive" src={img4} /></a></div>
                        <div className="col-lg-3 col-sm-4 col-xs-6"><a onClick={this.open}><img className="thumbnail img-responsive" src={img5} /></a></div>
                        <div className="col-lg-3 col-sm-4 col-xs-6"><a onClick={this.open}><img className="thumbnail img-responsive" src={img6} /></a></div>
                        <div className="col-lg-3 col-sm-4 col-xs-6"><a onClick={this.open}><img className="thumbnail img-responsive" src={img7} /></a></div>
                        <div className="col-lg-3 col-sm-4 col-xs-6"><a onClick={this.open}><img className="thumbnail img-responsive" src={img8} /></a></div>
                        <div className="col-lg-3 col-sm-4 col-xs-6"><a onClick={this.open}><img className="thumbnail img-responsive" src={img9} /></a></div>
                        <div className="col-lg-3 col-sm-4 col-xs-6"><a onClick={this.open}><img className="thumbnail img-responsive" src={img10} /></a></div>
                        <div className="col-lg-3 col-sm-4 col-xs-6"><a onClick={this.open}><img className="thumbnail img-responsive" src={img11} /></a></div>
                        <div className="col-lg-3 col-sm-4 col-xs-6"><a onClick={this.open}><img className="thumbnail img-responsive" src={img12} /></a></div>
                        <div className="col-lg-3 col-sm-4 col-xs-6"><a onClick={this.open}><img className="thumbnail img-responsive" src={img13} /></a></div>
                        <div className="col-lg-3 col-sm-4 col-xs-6"><a onClick={this.open}><img className="thumbnail img-responsive" src={img14} /></a></div>
                        <div className="col-lg-3 col-sm-4 col-xs-6"><a onClick={this.open}><img className="thumbnail img-responsive" src={img15} /></a></div>
                        <div className="col-lg-3 col-sm-4 col-xs-6"><a onClick={this.open}><img className="thumbnail img-responsive" src={img16} /></a></div>
                        <div className="col-lg-3 col-sm-4 col-xs-6"><a onClick={this.open}><img className="thumbnail img-responsive" src={img17} /></a></div>
                        <div className="col-lg-3 col-sm-4 col-xs-6"><a onClick={this.open}><img className="thumbnail img-responsive" src={img18} /></a></div>
                        <div className="col-lg-3 col-sm-4 col-xs-6"><a onClick={this.open}><img className="thumbnail img-responsive" src={img19} /></a></div>
                        <div className="col-lg-3 col-sm-4 col-xs-6"><a onClick={this.open}><img className="thumbnail img-responsive" src={img20} /></a></div>
                        <div className="col-lg-3 col-sm-4 col-xs-6"><a onClick={this.open}><img className="thumbnail img-responsive" src={img21} /></a></div>
                        <div className="col-lg-3 col-sm-4 col-xs-6"><a onClick={this.open}><img className="thumbnail img-responsive" src={img22} /></a></div>
                        <div className="col-lg-3 col-sm-4 col-xs-6"><a onClick={this.open}><img className="thumbnail img-responsive" src={img23} /></a></div>
                    </div>
                </div>

                <Modal show={this.state.showModal} onHide={this.close}>
                    <Modal.Header closeButton />
                    <Modal.Body>
                        <img className="img-responsive"  src={this.state.selectedImage}/>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.close}>Close</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
  }
}

const mapStateToProps = (state) => {
    return {
        "galleries": state.galleries,
        "selectedImage": state.selectedImage
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        "selectImage": (image) => dispatch(selectImage(image)),
        "clearSelection": () => dispatch(clearImageSelection())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Gallery)



// WEBPACK FOOTER //
// ./src/components/Gallery.js